import { render, staticRenderFns } from "./InventoryLineItemsTable.vue?vue&type=template&id=4decb0d4&scoped=true&"
import script from "./InventoryLineItemsTable.vue?vue&type=script&lang=ts&"
export * from "./InventoryLineItemsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4decb0d4",
  null
  
)

export default component.exports